import { createFileRoute } from '@tanstack/react-router';

import { HStack, Spacer } from '@/components/Layout';

import InnerNavigation from './-components/InnerNavigation';
import ManualForm from './-components/ManualForm';
import { ProgressCard } from './-components/ProgressCard';

export const Route = createFileRoute('/_staff/person/add/$workerType/')({
  component: () => <Form />,
});

function Form() {
  return (
    <HStack className="p-6 w-full">
      <InnerNavigation />
      <Spacer variant="m" />
      <ManualForm className="grow" />
      <Spacer variant="m" />
      <ProgressCard />
    </HStack>
  );
}
